import en from './en.json'

const caseStudiesLocales = { en }

export default caseStudiesLocales
